/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether a prize pool is a single summable amount or a tier table. TIERS pools have no single figure to display or sum, and cards render them as "Prize Tiers" rather than an amount.
 * 
 * @export
 */
export const CompetitionPrizePoolType = {
    MONETARY: 'MONETARY',
    TIERS: 'TIERS'
} as const;
export type CompetitionPrizePoolType = typeof CompetitionPrizePoolType[keyof typeof CompetitionPrizePoolType];


export function instanceOfCompetitionPrizePoolType(value: any): boolean {
    for (const key in CompetitionPrizePoolType) {
        if (Object.prototype.hasOwnProperty.call(CompetitionPrizePoolType, key)) {
            if (CompetitionPrizePoolType[key as keyof typeof CompetitionPrizePoolType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionPrizePoolTypeFromJSON(json: any): CompetitionPrizePoolType {
    return CompetitionPrizePoolTypeFromJSONTyped(json, false);
}

export function CompetitionPrizePoolTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionPrizePoolType {
    return json as CompetitionPrizePoolType;
}

export function CompetitionPrizePoolTypeToJSON(value?: CompetitionPrizePoolType | null): any {
    return value as any;
}

export function CompetitionPrizePoolTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionPrizePoolType {
    return value as CompetitionPrizePoolType;
}

